<template>
    <div class="qksm qksm2">
        <h4>二、收入决算情况说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}本年收入合计{{isMoney(T2.总计)}}万元，其中：
                <template v-for="(item, idx) in T2.项目">
                    {{item.name}}{{isMoney(item.value)}}万元，占{{getPercentValue(T2.项目.map(e=>e.value), idx, 2)}}{{idx==T2.项目.length-1?'。':'；'}}
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm2",
        data() {
            return {
                isPdf: this.$parent.isPdf
            }
        },
        props: {
            T2: {
                type: Object,
                default: "",
            },
        },
    };
</script>
